
  <!--<printheaderview></printheaderview>-->
  

  <div class="row">
    <div class="col-print-12 padding-left-0px">
      <div class="card">
        <div class="card-header padding-left-0px border-bottom-0 padding-top-0px padding-bottom-0px"></div>
        <div class="card-body padding-top-0px padding-bottom-0px font-weight-normal">

          <div class="row">
            <div class="col-print-12 text-align-center">
              <label class="font-familyhead">Embryo Transfer</label>
              <qrcode class="padding-top-0px padding-bottom-0px qr-style3" [qrdata]="PatientId" [size]="90" [level]="'M'"></qrcode>
            </div>
          </div>

          <div class="col-print-12 bordertop border-bot-1px border-bottom-1px">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-5 margin-top-10 margin-bottom-10px">
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Patient:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-bold">{{Owner}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Gender/Age:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{Gender}}/{{Age}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Patient ID:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{PatientId}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Infertility Type:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{Infertility}}</label>
                  </div>
                </div>
              </div>

              <div class="col-print-1"></div>

              <div class="col-print-5 margin-top-10 margin-bottom-10px">
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Cycle:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{CycleType}} ({{CycleNo}})</label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Protocol:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{Protocol}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Protocol Start:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{ProtocolStart | date:'dd-MMM-yyyy'}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Protocol End:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{ProtocolEnd | date:'dd-MMM-yyyy'}}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-print-12">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-4">
                <label class="margin-bottom-0px font-family font-weight-bold">Embryo Transfer Procedure:</label>
              </div>
              <div class="col-print-6">
                <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
              </div>
            </div>
          </div>
          <div class="col-print-12 bordertop border-bot-1px border-bottom-1px">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-5 margin-top-10 margin-bottom-10px">
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-bold">Team</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-bold"></label>
                  </div>
                </div>

                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Surgeon:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-bold">{{Surgeon}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Asst.Surgeon:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{AsstSurgeon}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Embryologist:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{Embryologist}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Anaesthesiologist:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{Anaesthesiologist}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Anaesthesia:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{Anaesthesia}}</label>
                  </div>
                </div>
              </div>

              <div class="col-print-1"></div>

              <div class="col-print-5 margin-top-10 margin-bottom-10px">
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-bold">Schedule</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-bold"></label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Planned Time:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{PlannedTime | date:'hh:mm:ss'}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Actual Date:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{DSADOC}} {{DSASTIMULATION}} {{DSAANTAG}} ({{ActualDate | date:'dd-MMM-yyyy'}})</label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Actual Time:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{ActualTime | date:'hh:mm:ss'}}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>



          <div class="col-print-12">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-4">
                <label class="margin-bottom-0px font-family font-weight-bold">Day Of HCG :</label>
              </div>
              <div class="col-print-6">
                <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
              </div>
            </div>
          </div>
          <div class="col-print-12 bordertop border-bot-1px border-bottom-1px">            
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-5 margin-top-10 margin-bottom-10px">

                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Trigger Date:</label>
                  </div>
                  <div class="col-print-6" *ngFor="let l of CurrentFollicularPickUpsByCodeController">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{l.OvulationTriggerDate | date:'dd-MMM-yyyy'}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Trigger Time:</label>
                  </div>
                  <div class="col-print-6" *ngFor="let l of CurrentFollicularPickUpsByCodeController">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{l.OvulationTriggerTime}}</label>
                  </div>
                </div>
                <!--<div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Batch:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
                  </div>
                </div>-->

              </div>

              <div class="col-print-1"></div>

              <div class="col-print-5 margin-top-10 margin-bottom-10px">

                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Medicine:</label>
                  </div>
                  <div class="col-print-6" *ngFor="let l of CurrentFollicularPickUpsByCodeController">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{l.MedicineName}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Dose:</label>
                  </div>
                  <div class="col-print-6" *ngFor="let l of CurrentFollicularPickUpsByCodeController">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{l.Dosage}}</label>
                  </div>
                </div>

              </div>
            </div>
          </div>
          <!--<div class="col-print-12">
    <div class="row margin-left-0px">
      <div class="col-print-2">
        <label class="margin-bottom-0px font-family font-weight-normal"></label>
      </div>
      <div class="col-print-6">
        <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
      </div>
    </div>
  </div>-->

          <div class="col-print-12">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-4">
                <label class="margin-bottom-0px font-family font-weight-bold">Embryo Transfer</label>
              </div>
              <div class="col-print-6">
                <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
              </div>
            </div>
          </div>
          <div class="col-print-12">
            <div class="row margin-left-0px text-center margin-right-0px">
              
              <div class="col-print-3 bordertop border-bot-1px border-right-1px border-left-1px margin-right-10px" *ngFor="let l of TransferrableList">
                <div class="row margin-left-0px margin-right-0px border-bot-1px">
                  <div class="col-print-6 border-right-1px">
                    <div class="row margin-left-0px">
                      <div class="col-print-10 text-center">
                        <label class="margin-bottom-0px margin-top-0px font-family font-weight-normal">Doc</label>
                      </div>
                    </div>

                    <div class="row margin-left-0px">
                      <div class="col-print-10 text-center">
                        <label class="margin-bottom-0px margin-top-0px font-family font-weight-bold">{{GetMaxDOC(l)}}</label>
                      </div>
                    </div>
                  </div>
                  <div class="col-print-6 padding-left-10px">
                    <div class="row margin-left-0px">
                      <div class="col-print-10 text-center">
                        <label class="margin-bottom-0px margin-top-0px font-family font-weight-normal">Grade</label>
                      </div>
                    </div>
                    <div class="row margin-left-0px">
                      <div class="col-print-10 text-center">
                        <label class="margin-bottom-0px margin-top-0px font-family font-weight-bold">{{GetMaxGrade(l)}}</label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row margin-left-0px padding-top-10px padding-bottom-10px">
                  <div class="col-print-11 text-center">
                    <img class="nav-link-hand img5" [src]="GetMaxImageUrl(l)" onError="this.src='Day-5-Embryo.jpg';">
                    <!--<img class="nav-link-hand img5" src="Day-5-Embryo.jpg">-->
                  </div>


                </div>
              </div>
              <div class="col-print-1"></div>
              
            </div>
          </div>
          <div class="col-print-12">
            <div class="row margin-left-0px">
              <div class="col-print-2">
                <label class="margin-bottom-0px font-family font-weight-normal"></label>
              </div>
              <div class="col-print-6">
                <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
              </div>
            </div>
          </div>
          <div class="col-print-12">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-4">
                <label class="margin-bottom-0px font-family font-weight-bold">Transfer Details:</label>
              </div>
              <div class="col-print-6">
                <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
              </div>
            </div>
          </div>
          <!--<div class=""></div>-->
          <div class="col-print-12 bordertop border-bot-1px border-bottom-1px">
            <div class="row margin-left-0px">
              <div class="col-print-5 margin-top-10 margin-bottom-10px">
                <div class="row margin-left-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Culture Media Used:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-bold">{{CultureMedia}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Method:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{Method}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Catheter Type:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{CatheterType}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Catheter Used:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{CatheterUsed}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Speculum Used:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{SpeculumUsed}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Media Cleaning of Cervical Canal:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{CervicalCleaning}}</label>
                  </div>
                </div>
                <!--<div class="row margin-left-0px">
          <div class="col-print-6">
            <label class="margin-bottom-0px font-family font-weight-normal">No.Of Transfer Attempts:</label>
          </div>
          <div class="col-print-6">
            <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
          </div>
        </div>
        <div class="row margin-left-0px">
          <div class="col-print-6">
            <label class="margin-bottom-0px font-family font-weight-normal">Endo Thickness on the day of HCG:</label>
          </div>
          <div class="col-print-6">
            <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
          </div>
        </div>-->

              </div>

              <div class="col-print-1 margin-top-10 margin-bottom-10px"></div>

              <div class="col-print-5 margin-top-10 margin-bottom-10px">
                <div class="row margin-left-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Retained Embryos:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{RetainedEmbryos}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Fragmentation:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{Fragmentation}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Cervical Mucus:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{CervicalMucus}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Technique:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{Technique}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Blood on Catheter:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{BloodOnCatheter}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Retransfer:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{Retransfer}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Embryo Transfer:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{EmbryoTransfer}}</label>
                  </div>
                </div>
                <!--<div class="row margin-left-0px">
          <div class="col-print-6">
            <label class="margin-bottom-0px font-family font-weight-normal">Endometrial pattern on the day of HCG:</label>
          </div>
          <div class="col-print-6">
            <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
          </div>
        </div>
        <div class="row margin-left-0px">
          <div class="col-print-6">
            <label class="margin-bottom-0px font-family font-weight-normal">Day of HCG Trigger:</label>
          </div>
          <div class="col-print-6">
            <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
          </div>
        </div>
        <div class="row margin-left-0px">
          <div class="col-print-6">
            <label class="margin-bottom-0px font-family font-weight-normal">Day of Embryo Transfer:</label>
          </div>
          <div class="col-print-6">
            <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
          </div>
        </div>-->

              </div>
            </div>
          </div>

          <!--<div class="pagebrkaft"></div>-->
          <div class="col-print-12">
            <div class="row margin-left-0px">
              <div class="col-print-2">
                <label class="margin-bottom-0px font-family font-weight-normal"></label>
              </div>
              <div class="col-print-6">
                <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
              </div>
            </div>
          </div>

          <div class="col-print-12">

            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-3">
                <label class="margin-bottom-0px font-family font-weight-normal">Tests:</label>
              </div>
              <div class="col-print-8">
                <div class="row">
                  <div class="col-print-6 padding-left-15px">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div class="col-print-12">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-3"></div>
              <div class="col-print-6">
                <div class="table-component margin-bottom-0px border4">
                  <div class="table-responsive">
                    <table class="table table-striped margin-left-zero">
                      <tr>
                        <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family width-35px text-align-center">
                          S.No
                        </th>

                        <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family text-align-left">
                          Test Name
                        </th>

                        <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family width-70px">
                          Result
                        </th>

                      </tr>
                      <tr *ngFor="let l of CurrentIvfCycleTestByCodeController ; let RowIndex = index ">
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{RowIndex+1}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-left">{{l.TestName}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{l.Result}}{{l.ResultUnits}}</td>
                      </tr>

                    </table>

                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="pagebrkaft"></div>
          <div class="col-print-12">
            <div class="row margin-left-0px">
              <div class="col-print-3">
                <label class="margin-bottom-0px font-family font-weight-normal"></label>
              </div>
              <div class="col-print-8">
                <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
              </div>
            </div>
          </div>
          <div class="col-print-12">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-3">
                <label class="margin-bottom-0px font-family font-weight-normal">Medicines:</label>
              </div>
              <div class="col-print-8">
                <div class="row">
                  <div class="col-print-6 padding-left-15px">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
                  </div>
                </div>

              </div>

            </div>
          </div>
          <div class="col-print-12">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-3"></div>
              <div class="col-print-6">
                <div class="table-component margin-bottom-0px border4">
                  <div class="table-responsive">
                    <table class="table table-striped margin-left-zero">
                      <tr>
                        <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family width-35px text-align-center">
                          S.No
                        </th>

                        <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family text-align-left">
                          Medicine Name
                        </th>

                        <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family">
                          Dose
                        </th>

                      </tr>
                      <tr *ngFor="let l of CurrentIvfCycleMedicineByCodeController ; let RowIndex = index ">
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{RowIndex+1}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-left">{{l.MedicineName}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{l.Dosage}} {{l.DurationType}}</td>
                      </tr>

                    </table>

                  </div>
                </div>
              </div>
            </div>
          </div>
            <div class="col-print-12">
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family"></label>
                </div>
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family"></label>
                </div>
              </div>
            </div>
            <div class="col-print-12">
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-7">
                  <label class="margin-bottom-0px font-family">Surgeon</label>
                </div>
                <div class="col-print-5">
                  <label class="margin-bottom-0px font-family">Assistant Surgeon</label>
                </div>
              </div>
            </div>
            <div class="col-print-12">
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family"></label>
                </div>
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family"></label>
                </div>
              </div>
            </div>
            <div class="col-print-12">
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-7">
                  <div class="row margin-left-0px margin-right-0px">
                    <div class="col-print-4 border-bot-1px">
                      <label class="margin-bottom-0px font-family text-align-center">{{Surgeon}}</label>
                    </div>
                    <div class="col-print-6">
                      <label class="margin-bottom-0px font-family"></label>
                    </div>
                  </div>
                </div>
                <div class="col-print-5">
                  <div class="row margin-left-0px margin-right-0px">
                    <div class="col-print-6 border-bot-1px">
                      <label class="margin-bottom-0px font-family text-align-center">{{AsstSurgeon}}</label>
                    </div>
                    <div class="col-print-5">
                      <label class="margin-bottom-0px font-family"></label>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
    </div>
  </div>



  <!--<printfooterview></printfooterview>-->



